import React, { useEffect, useState } from 'react';
import {
  SignOutButton,
  SignedOut,
  SignedIn,
  useAuth
} from '@clerk/clerk-react';
import { usePlatformStore } from '@/hooks/usePlatformStore';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import {
  getKeyFromUrlSearch,
  getRealRouterFromUrl,
  getStoredReferralCode,
  getSignupReferralCodeInput,
  clearSignupReferralCodeInput
} from '@/biz/tool';
import { getHomeUrl } from '@/biz/tool';
import { buildLoginUrl, buildSignupUrl } from '@/biz/tool';
import axiosInstance from '@/apis/axiosInstance';
import { Button } from 'aha-components';
import { MenuList } from 'aha-components';
import Popper from '@material-ui/core/Popper';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Drawer from '@material-ui/core/Drawer';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {
  NavDealsIcon,
  NavWalletIcon,
  RocketIcon,
  HelpCenterIcon,
  WebsiteIcon,
  LeftArrowIcon,
  RightArrowIcon,
  ExitIcon,
  MessageIcon,
  SettingsIcon,
  LogoutIcon,
  HomeIcon,
  InvitesIcon,
  CreditScoreIcon,
  LanguageIcon
} from '@/components/common/icon';
import {
  getOrderId,
  hasClerkUser,
  isMobile,
  isFromApp,
  notMatch,
  getClerkSignOutRedirectUrl,
  getClerkSignupRedirectUrlPayload,
  localStorageSaveUtmMediumAndSource
} from '@/biz/tool';
import { useNavStore } from '@/hooks/useNavStore';
import { useLoginStore } from '@/hooks/useLoginStore';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { useSettingsStore } from '@/hooks/useSettingsStore';
import { useBaselineConfig } from '@/hooks/useBaselineConfig';
import { useInfluencerInfo } from '@/hooks/useInfluencerInfo';
import { Tooltip } from 'aha-components';
import { LoginDetailBottomButton } from '@/components/web/components/loginDetailBottomButton';
import toast from 'react-hot-toast';
import ModalLoginSuccess from '@/components/web/components/ModalLoginSuccess';
import ModalLoginAndJoinCampaign from '@/components/web/components/ModalLoginAndJoinCampaign';
import ModalNotInterestSubmit from '@/components/web/components/ModalNotInterestSubmit';
import ModalSelectPlatformContent from '@/components/web/components/ModalSelectPlatformContent';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import ModalSelectPlatform from '@/components/web/components/ModalSelectPlatform';
import ContactInformationModal from '@/components/web/components/contactInformationModal';
import ModalMissOut from '@/components/web/components/ModalMissOut';
import ModalSelectInvitedOrder from '@/components/web/components/ModalSelectInvitedOrder';
import ModalSelectInvitedOrderByNoMatch from '@/components/web/components/ModalSelectInvitedOrderByNoMatch';
import ModalAnalysis from '@/components/web/components/ModalAnalysis';
import ModalConfirmDealPrice from '@/components/web/components/ModalConfirmDealPrice';
import ModalSubmitInterest from '@/components/web/components/ModalSubmitInterest';
import ModalAddress from '@/components/web/components/ModalAddress';
import ModalWithdrawThisCollaboration from '@/components/web/components/ModalWithdrawThisCollaboration';
import ModalDealWithdrawn from '@/components/web/components/ModalDealWithdrawn';
import ModalEducation from '@/components/web/components/ModalEducation';
import ModalAuthorizationCode from '@/components/web/components/ModalAuthorizationCode';
import { useTranslation } from 'react-i18next';
import i18n, { langList } from '@/i18n';
import Popover from '@material-ui/core/Popover';
import getEnv from '@/utils/getEnv';
import {
  getUserLang,
  handleI18nChange,
  handleLangConflict
} from '@/i18n/utils';
import BottomDrawer from './components/BottomDrawer';
import PaymentSecured from '../PaymentSecured';
import ModalPublishTime from './components/ModalPublishTime';
import ModalCreditScore from './components/ModalCreditScore';
import ModalPromotionalLinkEducation from './components/ModalPromotionalLinkEducation';
import { resourcesItems } from './home/config';
import NavRate from './components/NavRate';
import ModalEmailVerification from './components/ModalEmailVerification';
import maskEmail from '@/utils/maskEmail';
import ModalNotMatchTips from './components/ModalNotMatchTips';
import ModalShowImage from './components/ModalShowImage';
import ModalRefuseCampaign from './components/ModalRefuseCampaign';
import ReferralMenuBanner from './home/ReferralMenuBanner';
import ModalPausedTip from './components/ModalPausedTip';
import ModalSoftDeleteTip from './components/ModalSoftDeleteTip';
import { useTimModalStore } from '@/tim/useTimModalStore';

const ModalBox = () => {
  return (
    <>
      {/* 登录成功弹窗 */}
      <ModalLoginSuccess />
      {/* 登录并加入活动弹窗 */}
      <ModalLoginAndJoinCampaign />
      {/* 拒绝订单 */}
      <ModalRefuseCampaign />
      {/* 不感兴趣 提交后弹窗 */}
      <ModalNotInterestSubmit />
      {/* 回到顶部按钮 */}
      <ScrollToTop />
      {/* 授权弹窗 */}
      <ModalSelectPlatform />
      {/* 添加新的联系方式弹窗 */}
      <ContactInformationModal />
      {/* 加入后 选择邀请订单弹窗 */}
      <ModalSelectInvitedOrder />
      {/* 加入弹窗 1. */}
      <ModalAnalysis />
      {/* 改价弹窗 2. */}
      <ModalConfirmDealPrice />
      {/* 确认加入 3. */}
      <ModalSubmitInterest />
      {/* 挽留弹窗 */}
      <ModalMissOut />
      {/* 选择邀请订单弹窗 success | noMatch */}
      <ModalSelectInvitedOrderByNoMatch />
      {/* 实体地址弹窗 */}
      <ModalAddress />
      {/*  */}
      {/* 撤回申请弹窗 */}
      <ModalWithdrawThisCollaboration />
      <ModalDealWithdrawn />
      {/* 达人逾期教育弹窗 */}
      <ModalEducation />
      {/* TT instagram authorization code 教育弹窗 */}
      <ModalAuthorizationCode />
      {/* 发布时间提示弹窗 */}
      <ModalPublishTime />
      {/* Promotional link Education信用分弹窗 */}
      <ModalPromotionalLinkEducation />
      {/* 信用分弹窗 */}
      <ModalCreditScore />
      {/* 邮箱验证弹窗 */}
      <ModalEmailVerification />
      {/* 不匹配提示弹窗 */}
      <ModalNotMatchTips />
      {/* 图片放大预览 */}
      <ModalShowImage />
      {/* 活动暂停提示弹窗 */}
      <ModalPausedTip />
      {/* 软删订单提示弹窗 */}
      <ModalSoftDeleteTip />
    </>
  );
};

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
      setVisible(scrolled > 300);
    };

    window.addEventListener('scroll', toggleVisible);
    return () => window.removeEventListener('scroll', toggleVisible);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!visible) return null;

  return (
    <div
      onClick={scrollToTop}
      className={`fixed w-10 h-10 bg-white rounded-full shadow-lg cursor-pointer flex items-center justify-center hover:bg-gray-50 transition-all z-50
      ${isMobile() ? 'bottom-[74px] right-[20px]' : 'bottom-28 right-[54px]'}
      `}
    >
      <svg
        className="w-5 h-5 text-gray-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 10l7-7m0 0l7 7m-7-7v18"
        />
      </svg>
    </div>
  );
};

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { timUnreadCount, setShowTimModal } = useTimModalStore();
  const {
    setInfluencers,
    influencers: storeInfluencers,
    setUser
  } = usePlatformStore();
  const { setCollaborationConfig } = useSettingsStore();
  const { setBaselineConfig } = useBaselineConfig();
  const { detailData } = useDetailDataStore();
  const pathname = window.location.pathname;
  const navigate = useNavigate();
  // 获取达人信息
  const router = useLocation();
  const { setChannelAvatar, setChannelName, setUserEmail, setUserAddressInfo } =
    useLoginStore();
  const {
    closeModalEmailVerification,
    showContactInformationModal,
    setShowModalEmailVerification,
    setFirstApplyVerifyEmailVerified,
    setHasAppliedOrder
  } = useWebModalStore();
  const { refresh: fetchInfluencerInfo } = useInfluencerInfo();
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  // 预期这里一定有 localStorage 值，因为 detector 在前
  // 这里强制 sync 到 localStorage，例如有非法值或空值
  const initUserLang = getUserLang(true).detectedValue;
  const REFERRALCODE =
    getKeyFromUrlSearch('REFERRALCODE') || getStoredReferralCode() || '';

  /** 优先使用注册页输入框的邀请码（OAuth 回调后 URL 常无 REFERRALCODE，缓存又是旧值） */
  const getReferralCodeToSend = () =>
    getSignupReferralCodeInput() ?? REFERRALCODE;

  const setReferralCode = async () => {
    const codeToSend = getReferralCodeToSend();
    if (!codeToSend) return;
    try {
      const {
        data: { code, message }
      } = await axiosInstance.post(`/user/referralCode`, {
        referralCode: codeToSend
      });
      clearSignupReferralCodeInput();
    } catch (error) {
      console.error('setReferralCode error: ', error);
    }
  };

  const refreshCreatorInfo = async () => {
    const pathname = window.location.pathname;
    const search = window.location.search;
    const current = `${pathname}${search}`;
    try {
      const payload = await fetchInfluencerInfo();
      if (!payload) return;

      const { influencers, user } = payload;
      // 保存是否申请订单&验证邮件状态； 申请过订单 但是还没有验证邮件，则弹出验证邮件弹窗
      setFirstApplyVerifyEmailVerified(user?.firstApplyVerifyEmailVerified);
      setHasAppliedOrder(user?.hasAppliedOrder);
      if (
        !user?.firstApplyVerifyEmailVerified &&
        user.hasAppliedOrder &&
        !closeModalEmailVerification
      ) {
        setShowModalEmailVerification(true);
      }
      // 邀请码：先看 URL，注册后跳转到 / 或 /connect 时 URL 已无 REFERRALCODE，用 storage 兜底（App 在进入带 REFERRALCODE 的页时已写入）

      // console.log(window.location.pathname.includes('detail'));
      if (influencers) {
        setInfluencers(influencers);
      }
      if (user?.collaborationConfig) {
        setCollaborationConfig(user?.collaborationConfig);
      }
      if (user?.baselineConfig) {
        setBaselineConfig(user?.baselineConfig);
      }
      if (influencers && !influencers?.length) {
        // 这里判断如果有邀请码就发送给后端（优先用注册页输入框的值）
        if (getReferralCodeToSend()) {
          await setReferralCode();
        }
        // if (pathname === '/') {
        //   // 没找到达人信息， 需要跳转到达人连接页面
        //   window.location.replace('/connect');
        // }
      }
      setUser(user);
      const info: any = influencers?.[0] || {};

      // 设置info, 登录没授权则没有
      if (info) {
        setChannelAvatar(info?.profilePictureLink);
        setChannelName(info?.name);
      }
      // 设置邮箱，登录就有
      if (user) {
        setUserEmail(user?.email);
        setUserAddressInfo(user?.addressInfo);
        // 如果 API 获取的 lang 和检测(ls)出来的不一致，则重写缓存并刷新。前提是接口下发值为默认值
        if (user.lang && user.lang !== 'auto') {
          if (user.lang !== initUserLang) {
            handleLangConflict(user.lang, initUserLang);
          }
        } else {
          // 是默认值，静默发个请求覆盖掉
          axiosInstance
            .post('/influencer/info', {
              lang: initUserLang
            })
            .catch(() => {
              /* eat errors */
            });
        }
      }
    } catch (error) {
      console.error('Influencer information query error:', error);
      const target = getHomeUrl({ showLoginModal: true });
      if (
        !current.includes('detail') &&
        !current.includes('connect') &&
        !current.includes('contactInfo') &&
        !current.includes('/?showLoginModal=1') &&
        !current.includes('/callback') &&
        !current.includes('/error') &&
        !current.includes('/loginError') &&
        current !== target
      ) {
        // window.location.href = getHomeUrl({ showLoginModal: true });
      }
      // 存储 utm_medium
      // 存储 utm_source
      localStorageSaveUtmMediumAndSource();
      //
      if (current.includes('/?showLoginModal=1')) {
        // 清除url中的loginSuccess参数
        window.history.pushState({}, '', getHomeUrl());
      }
    }
  };

  // 监听路由变化
  useEffect(() => {
    // 设置 tab 激活
    const router = getRealRouterFromUrl();
    if (router) {
      useNavStore.setState({ activity: router });
    }
    if (pathname.includes('/settings')) {
      useNavStore.setState({ activity: 'settings' });
    }

    // 全局整体鉴权
    refreshCreatorInfo();
  }, [router]);

  useEffect(() => {
    // 这里的 showContactInformationModal 是当前值

    return () => {
      // 这里的 showContactInformationModal 是变化前的值
      if (showContactInformationModal === true) {
        // 说明从 true 变为 false
        // 刷新一下 info
        refreshCreatorInfo();
      }
    };
  }, [showContactInformationModal]);

  useEffect(() => {
    // 仅在移动端时，当 detailData 更新时滚动到顶部
    if (isMobile()) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    if (detailData?.user && pathname.includes('detail')) {
      const isNotMatch = notMatch({ detailData });
      if (isNotMatch) {
        setTimeout(() => {
          if (detailData?.order?.user?.email) {
            toast.error(
              t('common.social_account_linked_email', {
                defaultValue:
                  'This social account is already linked to {{email}}. Please sign in with this email, or contact support if you need to update it.',
                email: maskEmail(detailData?.order?.user?.email)
              })
            );
          } else {
            toast.error(
              t('common.social_account_linked', {
                defaultValue:
                  'Your social account is linked to a different email address. Please use that email to sign in to the platform. If you have any further questions, feel free to contact our support team.'
              })
            );
          }
        }, 0);
      }
    }
  }, [detailData]);

  if (isMobile()) {
    return (
      <>
        <HeaderMobile />
        {/* 弹窗都放这里 */}
        <ModalBox />
      </>
    );
  }

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const viewportWidth = window.innerWidth;
  const shouldScale = viewportWidth < 1280 && viewportWidth > 800;
  const scaleValue = shouldScale ? viewportWidth / 1280 : 1;

  return (
    <>
      <div className="bg-white h-20" />
      <div className="bg-white fixed top-0 left-0 right-0 z-50">
        {/* <div className="bg-white sticky top-0 left-0 right-0 z-50"> */}
        <div
          className={`min-w-[1280px] max-w-[1440px] mx-auto border-b border-[#e8e8ec] ${shouldScale ? 'origin-left' : ''}`}
          style={
            shouldScale ? { transform: `scale(${scaleValue})` } : undefined
          }
        >
          <div className="h-20 flex justify-between items-center mx-10">
            {/* logo */}
            <div className="cursor-pointer" onClick={() => navigate('/')}>
              <img
                alt="logo"
                src="https://website-resource.ahaglobal.io/aha-brand-logo/aha-logo-name-black.png"
                className={'w-[160px]'}
              />
            </div>
            {/* menu */}
            <div className="">
              <NavbarComponent />
            </div>
            {/* user */}
            <div className="">
              <div className="h-10 justify-start items-center gap-4 inline-flex">
                <div className="justify-start items-center gap-1 flex text-[#0c67e6] cursor-pointer">
                  <div
                    className="relative flex items-center justify-center cursor-pointer hover:bg-[#F7F7F7] p-[8px] rounded-[8px]"
                    onClick={() => setShowTimModal(true)}
                  >
                    <MessageIcon className="w-5 h-5 text-[#292524]" />
                    {timUnreadCount > 0 && (
                      <div className="absolute right-[-6px] top-[-6px] min-w-[18px] h-[18px] rounded-full bg-[#ff4d4f] px-1 text-white text-[12px] flex items-center justify-center">
                        {timUnreadCount > 99 ? '99+' : timUnreadCount}
                      </div>
                    )}
                  </div>
                  <div
                    className="flex items-center gap-1 text-[#292524] text-sm cursor-pointer hover:bg-[#F7F7F7] px-[12px] py-[4px] rounded-[8px]"
                    onClick={() => {
                      window.open(
                        'https://chartreuse-wrinkle-697.notion.site/Creator-Help-Center-11804daded68800baa1bdea90409a469',
                        '_blank'
                      );
                    }}
                  >
                    <HelpCenterIcon className="w-5 h-5" />
                    <span>
                      {t('navbar.help.text', { defaultValue: 'Help Center' })}
                    </span>
                  </div>
                  {getEnv() === 'development' && (
                    <div className="test-env-only flex items-center hover:bg-[#F7F7F7] px-[12px] py-[4px] rounded-[8px]">
                      <WebsiteIcon className="w-[17px] h-[17px] text-[#292524] mr-[4px]" />
                      <div
                        onClick={handleClick}
                        className="text-sm text-[#292524]"
                      >
                        {langList.find(
                          (item) => item.detectedValue === initUserLang
                        )?.shortHand ?? langList[0].shortHand}
                      </div>
                      <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left'
                        }}
                        classes={{
                          root: '!rounded-[8px]',
                          paper: '!rounded-[8px]'
                        }}
                      >
                        <ul className="px-[8px] py-[16px]">
                          {langList.map((item) => (
                            <li
                              key={item.detectedValue}
                              onClick={() =>
                                handleI18nChange(item.detectedValue)
                              }
                              className="px-[16px] py-[8px] rounded-[16px] hover:bg-[#F9F9FB]"
                            >
                              <span className="text-sm font-medium font-['Inter'] leading-[22px]">
                                {item.label}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </Popover>
                    </div>
                  )}
                </div>
                {/* avatar 登录 登出 */}
                <Avatar />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 弹窗都放这里 */}
      <ModalBox />
    </>
  );
};

export default Header;

const HeaderMobile: React.FC = () => {
  const { t } = useTranslation();
  const { timUnreadCount, setShowTimModal } = useTimModalStore();
  const { activity } = useNavStore();
  const [menuOpen, setMenuOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const { isSignedIn } = useAuth();
  const { channelAvatar, channelName, userEmail } = useLoginStore();
  const navigate = useNavigate();

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev); // 切换菜单状态
  };

  const handleShare = () => {
    navigate('/campaign/share');
    setMenuOpen(false);
  };
  const menu = getMenu(activity, getOrderId());
  const headerName = menu.find((el) => el.active)?.label;
  const [isShowLanguageModal, setIsShowLanguageModal] = useState(false);
  const { setShowModalCreditScore } = useNavStore();
  const { user } = usePlatformStore();

  const fromApp = isFromApp();
  // 安全区占位只由 #app 的 pt 做一次即可；这里不再加 pt，否则会多出一条（和顶部固定白条重复）
  const topInsetClass = fromApp ? '' : 'pt-[0px]';
  const topFixedClass = fromApp
    ? 'top-[env(safe-area-inset-top,0px)]'
    : 'top-[0px]';

  return (
    <div className={`z-50 bg-white ${topInsetClass} ${fromApp ? '' : 'h-16'}`}>
      {/* 刘海屏时用不透明背景盖住安全区，只露出系统状态栏图标，不露出下方页面内容 */}
      {fromApp && (
        <div
          className="fixed left-0 right-0 top-0 h-[env(safe-area-inset-top,0px)] z-[9998]"
          style={{ backgroundColor: '#fff' }}
          aria-hidden
        />
      )}
      {/* 占位：非刘海屏 64px；刘海屏时由外层 pt 提供安全区，此处仍是导航栏高度 64px */}
      <div className="h-16" />
      <div
        className={`fixed left-0 right-0 w-[390px] h-16 p-4 bg-white justify-between items-center inline-flex z-[9999] ${topFixedClass}`}
      >
        <div className="">
          <img
            // alt="avatar"
            src={'/aha-head-creator-logo.svg'}
            className="h-[30px] cursor-pointer"
          />
        </div>
        <div className="text-[#1c2024] text-xl font-semibold font-['Geist'] leading-7 capitalize absolute left-1/2 -translate-x-1/2">
          {headerName}
        </div>
        <div className="w-7 h-7 relative" onClick={handleMenuToggle}>
          {/* 这里放移动端菜单,三个横向的menu菜单，点击从上弹出菜单区域 */}
          {timUnreadCount > 0 && !menuOpen && (
            <div className="absolute -top-1 -right-1 min-w-[16px] h-[16px] rounded-full bg-[#ff4d4f] px-[3px] text-white text-[10px] font-bold flex items-center justify-center z-10 pointer-events-none">
              {timUnreadCount > 99 ? '99+' : timUnreadCount}
            </div>
          )}
          <div className=" h-full w-full flex flex-col gap-[5px] justify-center items-center">
            {menuOpen ? ( // 根据菜单状态渲染不同的图标
              <>
                <div className="w-5 h-[2px] rounded-sm bg-black rotate-45 translate-y-[5px] transition-transform duration-300"></div>
                <div className="w-5 h-[2px] rounded-sm bg-black  transition-transform duration-300 hidden"></div>
                <div className="w-5 h-[2px] rounded-sm bg-black -rotate-45 translate-y-[-2px] transition-transform duration-300"></div>
              </>
            ) : (
              <>
                <div className="w-6 h-[2px] rounded-sm bg-black transition-transform duration-300"></div>
                <div className="w-6 h-[2px] rounded-sm bg-black transition-transform duration-300"></div>
                <div className="w-6 h-[2px] rounded-sm bg-black transition-transform duration-300"></div>
              </>
            )}
          </div>
        </div>
      </div>
      <Drawer
        anchor={'top'}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        PaperProps={{
          style: {
            marginTop: fromApp
              ? 'calc(env(safe-area-inset-top, 0px) + 64px)'
              : '64px',
            borderRadius: '0 0 16px 16px',
            boxShadow: 'none',
            padding: '40px 0 32px 0',
            height: '-webkit-fill-available'
          } // 设置顶部边距，App 内嵌时与导航栏对齐
        }}
      >
        {isSignedIn ? (
          // {/* 已登录 */}
          <div className="mb-8 mx-4 flex flex-col space-y-4 border-b border-[#eeeeee] pb-4">
            <Button
              className="!w-[358px] !h-full !border-none"
              onClick={() => {
                setTimeout(() => {
                  setAccountOpen(true);
                }, 200);
              }}
            >
              <div className="w-full flex justify-between items-center gap-3">
                <img
                  // alt="avatar"
                  className="w-12 h-12 rounded-[999px]"
                  src={channelAvatar}
                />
                <div className="grow shrink basis-0 h-11 justify-between items-center flex">
                  <div className="flex-col justify-start items-start inline-flex">
                    <div className="text-[#1c2024] text-base font-semibold font-['Geist'] leading-normal flex items-center gap-1">
                      {channelName || '--'}
                      <NavRate rate={user?.mixedScore} />
                    </div>
                    <div className="text-[#60646c] text-xs font-normal font-['Inter'] leading-tight">
                      {userEmail || '--'}
                    </div>
                  </div>
                  <RightArrowIcon
                    className={`w-6 h-6 ${isMobile() ? '' : 'hidden'}`}
                  />
                </div>
              </div>
            </Button>
          </div>
        ) : (
          // {/* 未登录 */}
          <div className="font-['Geist'] mx-4 mb-8">
            <div className="text-[#1c2024] text-2xl font-semibold leading-loose">
              {t('navbar.welcome.title', {
                defaultValue: 'Welcome to AhaCreator'
              })}
            </div>
            <div className="text-[#60646c] text-xs font-normal font-['Inter'] leading-[18px]">
              {t('navbar.welcome.description', {
                defaultValue:
                  'Log in with your Google account to start your high cashback journey on AhaCreator.'
              })}
            </div>
          </div>
        )}

        {/*  */}
        <NavbarComponent menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        <div
          className="mx-4 pl-[14px] pr-[10px] py-2 justify-between items-center flex hover:bg-[#f7f7f7] rounded-md cursor-pointer"
          onClick={() => {
            setShowTimModal(true);
            setMenuOpen(false);
          }}
        >
          <div className="flex items-center gap-2">
            <MessageIcon className="w-5 h-5" />
            <div className="text-[#1c2024] text-base font-normal font-['Geist'] leading-normal">
              {t('common.messages', { defaultValue: 'Messages' })}
            </div>
          </div>
          <div className="flex items-center gap-2">
            {timUnreadCount > 0 && (
              <div className="min-w-[18px] h-[18px] rounded-full bg-[#ff4d4f] px-1 text-white text-[12px] flex items-center justify-center">
                {timUnreadCount > 99 ? '99+' : timUnreadCount}
              </div>
            )}
            <RightArrowIcon className="w-6 h-6" />
          </div>
        </div>
        <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-zinc-100 mx-[20px]" />
        <div className="px-4 mt-8">
          <PaymentSecured />
        </div>
        {/*  */}
        <div className="flex flex-col gap-3 mb-4">
          {resourcesItems.map((item) => (
            <div
              className="h-[88px] mx-4 mt-2 px-4 py-3 bg-[#FAFAFA] rounded-2xl justify-start items-center gap-1 inline-flex"
              onClick={() => {
                window.open(item.link, '_blank');
              }}
            >
              <div className="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
                <div className="flex items-center gap-2">
                  <item.Icon className="w-6 h-6" />
                  <div className="grow shrink basis-0 flex-col justify-start items-start gap-0.5 inline-flex">
                    <div className="self-stretch text-[#1c2024] text-sm font-semibold font-['Geist'] leading-snug">
                      {t(item.title, {
                        defaultValue: item.title
                      })}
                    </div>
                  </div>
                </div>
                <div className="self-stretch text-[#60646c] text-xs font-normal font-['Inter'] leading-[18px]">
                  {t(item.desc, {
                    defaultValue: item.desc
                  })}
                </div>
              </div>
              <RightArrowIcon className="w-6 h-6" />
            </div>
          ))}
        </div>
        {/* 推荐邀请banner */}
        <ReferralMenuBanner setMenuOpen={setMenuOpen} />

        <div
          className="mx-4 h-10 pl-[14px] py-2 justify-between items-center inline-flex hover:bg-[#f7f7f7] rounded-lg"
          onClick={() => {
            navigate('/reviews');
            setMenuOpen(false);
          }}
        >
          <div className="flex justify-between items-center w-full">
            <div className="justify-start items-center gap-[11px] flex">
              <CreditScoreIcon className="w-5 h-5" />
              <div className="text-[#1c2024] text-base font-normal font-['Inter'] leading-normal">
                {t('navbar.menu.credit_score', {
                  defaultValue: 'Rating and Review'
                })}
              </div>
            </div>
            <RightArrowIcon className="w-6 h-6" />
          </div>
        </div>
        {/* 分割线 */}
        <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-zinc-100 mx-[20px]" />
        <div
          className="mx-4 h-10 pl-[14px] py-2 justify-between items-center inline-flex hover:bg-[#f7f7f7] rounded-lg"
          onClick={() => {
            navigate('/settings#connectSocials');
            setMenuOpen(false);
          }}
        >
          <div className="flex justify-between items-center w-full">
            <div className="justify-start items-center gap-[11px] flex">
              <SettingsIcon className="w-5 h-5" />
              <div className="text-[#1c2024] text-base font-normal font-['Inter'] leading-normal">
                {t('navbar.menu.settings', {
                  defaultValue: 'Settings'
                })}
              </div>
            </div>
            <RightArrowIcon className="w-6 h-6" />
          </div>
        </div>
        {/* 分割线 */}
        <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-zinc-100 mx-[20px]" />
        <div
          className="mx-4 h-10 pl-[14px] py-2 justify-between items-center inline-flex hover:bg-[#f7f7f7] rounded-lg"
          onClick={() => setIsShowLanguageModal(true)}
        >
          <div className="flex justify-between items-center w-full">
            <div className="justify-start items-center gap-[11px] flex">
              <LanguageIcon className="w-5 h-5" />
              <div className="text-[#1c2024] text-base font-normal font-['Inter'] leading-normal">
                {t('navbar.menu.language', { defaultValue: 'English' })}
              </div>
            </div>
            <RightArrowIcon className="w-6 h-6" />
          </div>
        </div>
        {/* 分割线 */}
        <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-zinc-100 mx-[20px]" />
        <BottomDrawer
          title=""
          visible={isShowLanguageModal}
          handleClose={() => setIsShowLanguageModal(false)}
          isShowFooter={false}
          rootClassName="!z-[9999]"
        >
          <div className="w-full pb-[10px]">Choose a language</div>
          {/* 分割线 */}
          <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-zinc-100 mx-[-20px]" />
          <ul className="pt-[10px]">
            {langList.map((item) => (
              <li
                key={item.detectedValue}
                className="px-[10px] py-[12px]"
                onClick={() => handleI18nChange(item.detectedValue)}
              >
                <div>{item.label}</div>
              </li>
            ))}
          </ul>
        </BottomDrawer>
        {isSignedIn ? (
          <div className="mx-4 h-10 pl-[14px] py-2 justify-between items-center inline-flex hover:bg-[#f7f7f7] rounded-lg">
            <SignedIn>
              <SignOutButton redirectUrl={getClerkSignOutRedirectUrl()}>
                <div className="flex justify-between items-center w-full">
                  <div className="justify-start items-center gap-[11px] flex">
                    <LogoutIcon className="w-5 h-5" />
                    <div className="text-[#1c2024] text-base font-normal font-['Inter'] leading-normal">
                      {t('navbar.menu.log_out', { defaultValue: 'Log out' })}
                    </div>
                  </div>
                  <RightArrowIcon className="w-6 h-6" />
                </div>
              </SignOutButton>
            </SignedIn>
          </div>
        ) : (
          <>
            <div className="flex-1"></div>
            <div className="flex justify-center items-center">
              <LoginDetailBottomButton desc={''} />
            </div>
          </>
        )}
      </Drawer>
      {/* Drawer Account */}
      <Drawer
        anchor={'top'}
        open={accountOpen}
        onClose={() => setAccountOpen(false)}
        ModalProps={{
          style: {
            zIndex: 99999
          }
        }}
        PaperProps={{
          style: {
            // marginTop: '64px',
            borderRadius: '0 0 16px 16px',
            boxShadow: 'none',
            padding: '0 0 32px 0',
            height: '-webkit-fill-available',
            zIndex: 99999
          } // 设置顶部边距
        }}
        keepMounted={true}
      >
        <div className="h-full">
          <div className="w-[390px] h-16 p-4 bg-white justify-between items-center inline-flex mb-6">
            <div className="" onClick={() => setAccountOpen(false)}>
              <LeftArrowIcon className="w-6 h-6" />
            </div>
            <div className="text-[#1c2024] text-xl font-semibold font-['Geist'] leading-7">
              {t('navbar.account.title', { defaultValue: 'Account' })}
            </div>
            <div className="w-7 h-7 p-[5.83px] opacity-0 justify-center items-center flex" />
          </div>
          <div className="flex flex-col p-4">
            <div className="h-10 py-2 justify-between items-center inline-flex">
              <div className="justify-start items-center gap-3 flex">
                <div className="text-[#1c2024] text-base font-normal font-['Inter'] leading-normal">
                  {t('navbar.account.title', { defaultValue: 'Account' })}
                </div>
              </div>
              <div className="justify-start items-center gap-2 flex">
                <div className="text-[#1c2024] text-base font-normal font-['Inter'] leading-normal">
                  {userEmail || '--'}
                </div>
              </div>
            </div>
            <div className="h-px bg-[#eeeeee] mt-4 mb-8"></div>
            <div className="">
              <div className="w-[307px] text-[#1c2024] text-base font-semibold font-['Geist'] leading-normal">
                {t('navbar.account.connect_social', {
                  defaultValue: 'Connect social accounts'
                })}
              </div>
              <div className="text-[#60646c] text-xs mb-6">
                <a
                  target="_blank"
                  className="ml-1 underline text-[#0c67e6]"
                  href="https://www.notion.so/11104daded68803fb924f34bbac22a76?pvs=25#11804daded68807d8342edb667ae343b"
                  rel="noreferrer"
                >
                  {t('navbar.account.learn_more', {
                    defaultValue: 'Learn more'
                  })}
                </a>{' '}
                {t('navbar.account.privacy_text', {
                  defaultValue: 'about how we protect your privacy.'
                })}
              </div>
              <div className="flex flex-col gap-2">
                <ModalSelectPlatformContent />
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

const NavbarComponent: React.FC<{
  menuOpen?: boolean;
  setMenuOpen?: Function;
}> = ({ menuOpen, setMenuOpen }) => {
  const { isSignedIn } = useAuth();
  const { activity, setActivity } = useNavStore();
  const orderId = getOrderId();
  const navigate = useNavigate();
  const { setShowLoginModal } = useNavStore();
  const menu = getMenu(activity, orderId);
  const pathname = window.location.pathname;

  if (
    !isMobile() &&
    (pathname.includes('/connect') ||
      pathname.includes('/contactInfo') ||
      pathname.includes('/match') ||
      pathname.includes('/clerk') ||
      pathname.includes('/auth'))
  ) {
    return null;
  }

  return (
    <div
      className={`flex
          ${isMobile() ? 'flex-col bg-white z-[49] px-4 rounded-b-2xl' : 'gap-8'}
        `}
    >
      {menu
        .filter((el) => !el.hidden)
        .map((el: any) => {
          return (
            <div key={el.key}>
              <Button
                key={el.key}
                onClick={() => {
                  if (el.mustLogin && !isSignedIn) {
                    if (isMobile()) {
                      return;
                    } else {
                      // 跳转首页
                      navigate('/');
                      return;
                    }
                  }

                  if (isMobile()) {
                    setMenuOpen && setMenuOpen(false);
                  }

                  if (el.menuClick) {
                    el.menuClick();
                  } else if (el.target === '_blank') {
                    window.open(el.navigate, '_blank');
                  } else {
                    setActivity(el.key);
                    navigate(el.navigate);
                  }
                }}
                className={`!w-full !h-full !p-0 !border-none ${isMobile() ? '!mb-1' : ''}`}
              >
                <div
                  className={`w-full flex items-center gap-2 text-base cursor-pointer font-['Geist'] py-2 hover:bg-[#f7f7f7]
                    ${el.active ? 'bg-[#f7f7f7] text-theme-color' : 'text-[#1c2024]'}
                    ${isMobile() ? '!w-[360px] pr-[10px] font-normal pl-[14px] rounded-md justify-between' : 'px-4 rounded-lg font-medium'}
                  `}
                >
                  <div className="flex gap-2">
                    {el.icon}
                    <div className={`${isMobile() ? 'flex-1' : ''}`}>
                      {el.label}
                    </div>
                  </div>
                  <RightArrowIcon
                    className={`w-6 h-6 ${isMobile() ? '' : 'hidden'}`}
                  />
                </div>
              </Button>
            </div>
          );
        })}
    </div>
  );
};

const Avatar: React.FC = () => {
  const { t } = useTranslation();
  const anchorRef = React.useRef<HTMLImageElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { avatarInformationOpen, setAvatarInformationOpen } = useNavStore();
  const { isSignedIn } = useAuth();
  const { detailData } = useDetailDataStore();
  const { setShowModalCreditScore } = useNavStore();
  const { channelAvatar, channelName, userEmail } = useLoginStore();
  const { user } = usePlatformStore();
  const {
    setShowSelectPlatformModal,
    setShowContactInformationModal,
    setShowImModal,
    imNum,
    setImNum
  } = useWebModalStore();
  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setAvatarInformationOpen(false);
  };

  function handleListKeyDown(event: any) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setAvatarInformationOpen(false);
    }
  }

  const items = [
    {
      key: 'user',
      label: '',
      render: () => (
        <div className="grow shrink basis-0 justify-start items-center flex p-4 min-w-[196px]">
          <div className="flex-col justify-start items-start inline-flex gap-2">
            <div className="text-[#1c2024] text-base font-semibold font-['Geist'] leading-normal flex items-center gap-1 justify-start w-[200px]">
              <Tooltip content={channelName} position="bottom">
                <div className="w-fit truncate">
                  {channelName ||
                    t('navbar.placeholder.name', {
                      defaultValue: '--'
                    })}
                </div>
              </Tooltip>
              <NavRate rate={user?.mixedScore} />
            </div>
            <div className="text-[#60646c] text-xs font-normal font-['Inter'] leading-tight">
              {userEmail ||
                t('navbar.placeholder.email', {
                  defaultValue: '--'
                })}
            </div>
          </div>
        </div>
      )
    },
    {
      children: [
        {
          key: 'reviews',
          label: t('navbar.menu.credit_score', {
            defaultValue: 'Rating and Review'
          }),
          onClick: () => {
            navigate('/reviews');
          }
        },
        {
          key: 'settings',
          label: t('navbar.menu.settings', {
            defaultValue: 'Settings'
          }),
          onClick: () => {
            navigate('/settings');
          }
        }
      ]
    },
    {
      key: 'logout',
      label: t('navbar.menu.logout', {
        defaultValue: 'Logout'
      }),
      danger: true,
      render: () => (
        <div className="p-4 pb-0 cursor-pointer">
          <SignOutButton redirectUrl={getClerkSignOutRedirectUrl()}>
            <div className="!w-full h-10 flex !justify-between !hover:bg-[#F9F9FB]">
              <span>
                {t('navbar.menu.logout', {
                  defaultValue: 'Logout'
                })}
              </span>
              <ExitIcon />
            </div>
          </SignOutButton>
        </div>
      )
    }
  ];

  return (
    <>
      {isSignedIn ? (
        <div className="relative">
          <img
            ref={anchorRef}
            // alt="avatar"
            src={
              hasClerkUser()
                ? channelAvatar || '/c-avatar-empty.svg'
                : '/c-avatar-empty.svg'
            }
            className="w-10 h-10 rounded-full border border-[#d9d9e0] cursor-pointer"
            onClick={() => {
              setAvatarInformationOpen(!avatarInformationOpen);
            }}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = '/c-avatar-empty.svg';
              console.error('youtube avatar failed!!! ' + channelAvatar);
            }}
          />
          {/* {imNum > 0 && (
            <div className="absolute right-[-12px] top-[-6px] w-[18px] h-[18px] rounded-full bg-[#ff4d4f] text-white text-[12px] flex items-center justify-center">
              {imNum > 99 ? '99+' : imNum}
            </div>
          )} */}
          <Popper
            open={avatarInformationOpen}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            placement={'bottom-end'}
            onMouseLeave={() => setAvatarInformationOpen(false)}
          >
            {({ TransitionProps, placement }) => (
              <Grow {...TransitionProps}>
                <Paper
                  className="!rounded-lg"
                  onMouseLeave={() => setAvatarInformationOpen(false)}
                >
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList items={items} onClick={handleListKeyDown} />
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      ) : (
        <>
          {/* 调试用 */}
          {/* <ClerkLoading></ClerkLoading>
          <ClerkLoaded>
            <SignedOut>
              <SignInButton />
            </SignedOut>
            <SignedIn>
              <UserButtons />
            </SignedIn>
          </ClerkLoaded> */}
          {/*  */}
          <Tooltip
            content={t('navbar.login.tooltip', { defaultValue: 'Login' })}
          >
            <SignedOut>
              <Link
                to={buildLoginUrl({
                  ...getClerkSignupRedirectUrlPayload(detailData),
                  ahaRedirect: location.pathname + location.search
                })}
                className="block"
              >
                <img
                  src="/c-avatar-empty.svg"
                  style={{
                    width: '40px',
                    height: '40px',
                    cursor: 'pointer'
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = '/c-logo.jpg';
                  }}
                />
              </Link>
            </SignedOut>
          </Tooltip>
        </>
      )}
      {/* 登录弹窗 */}
      {/* <LoginModal
        visible={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      /> */}
    </>
  );
};

const getMenu = (activity: string | null, orderId: string) => {
  return [
    {
      label: i18n.t('navbar.menu.today', { defaultValue: 'Today' }),
      key: 'today',
      icon: <HomeIcon className="w-[24px] h-[22px]" />,
      active: activity === 'today',
      navigate: `/`
    },
    {
      label: i18n.t('navbar.menu.invites', { defaultValue: 'Invites' }),
      key: 'invites',
      icon: <InvitesIcon className="w-[24px] h-[22px]" />,
      mustLogin: true,
      active: activity === 'invites',
      navigate: `/campaign/invites`
    },
    {
      label: i18n.t('navbar.menu.deals', { defaultValue: 'Deals' }),
      key: 'deals',
      icon: <NavDealsIcon className="w-[24px] h-[22px]" />,
      mustLogin: true,
      active: activity === 'deals',
      navigate: `/campaign/deals`
    },
    {
      label: i18n.t('navbar.menu.wallet', { defaultValue: 'Payment' }),
      key: 'wallet',
      icon: <NavWalletIcon className="w-[26px] h-[22px]" />,
      mustLogin: true,
      active: activity === 'wallet',
      navigate: `/campaign/wallet/${orderId}`
    },
    {
      label: i18n.t('navbar.menu.settings', { defaultValue: 'Settings' }),
      key: 'settings',
      icon: <RocketIcon className="w-5 h-5" />,
      mustLogin: true,
      hidden: true,
      active: activity === 'settings',
      navigate: '/settings'
    },
    {
      label: i18n.t('navbar.menu.logout', { defaultValue: 'Logout' }),
      key: 'logout',
      active: false,
      hidden: true,
      navigate: '',
      menuClick: () => {
        // window.location.reload();
      }
    }
  ];
};

// const UserButtons = () => {
//   const navigate = useNavigate();
//   return (
//     <UserButton
//       appearance={{
//         elements: {
//           avatarBox: 'h-10 w-10'
//         }
//       }}
//     >
//       <UserButton.MenuItems>
//         <UserButton.Action
//           label="connect social"
//           onClick={() => {
//             if (window.location.pathname.includes('/organization')) {
//               // navigate("#/payment");
//               window.location.hash = '#/payment';
//             } else {
//               navigate('/organization#/payment');
//             }
//           }}
//           labelIcon={<HelpIcon />}
//         />
//       </UserButton.MenuItems>
//     </UserButton>
//   );
// };
